/*导入Vue和VueRouter库，以及各个组件和状态管理库。*/
import Vue from 'vue'
import VueRouter from 'vue-router'
import {Message} from 'element-ui'
import Composite from "@/vue_views/components/Composite.vue";
import myVuex from "@/js_store/myVuex";
import Login from "@/vue_views/components/Login.vue";
import Register from "@/vue_views/components/Register.vue";
import NotFound from "@/vue_views/components/404.vue";
import Person from "@/vue_views/components/Person.vue";
import Password from "@/vue_views/components/Password.vue";
import AMeetingLoop from "@/vue_views/AMeetingLoop.vue";
import LoginH5 from "@/vue_views/h5/LoginH5.vue";
import RegisterH5 from "@/vue_views/h5/RegisterH5.vue";
import PasswordH5 from "@/vue_views/h5/PasswordH5.vue";
import HomeH5 from "@/vue_views/h5/HomeH5.vue";
import PersonH5 from "@/vue_views/h5/PersonH5.vue";
import MeetingH5 from "@/vue_views/h5/MeetingH5.vue";
import UserH5 from "@/vue_views/h5/UserH5.vue";
import RoleH5 from "@/vue_views/h5/RoleH5.vue";
import DocumentH5 from "@/vue_views/h5/DocumentH5.vue";
import MeetingH5Loop from "@/vue_views/h5/MeetingH5Loop.vue";
/*使用Vue.use(VueRouter)来启用VueRouter插件。*/
Vue.use(VueRouter)
/*定义了一个名为routes的常量，它是一个数组，包含了所有的路由配置。每个路由配置对象包含path、name和component属性，
分别表示路由的路径、名称和对应的组件。*/
const routes = [{path: '/login', name: 'login', component: Login}, {
    path: '/register', name: 'register', component: Register
}, {path: '/password', name: 'password', component: Password}, {path: '/404', name: '404', component: NotFound},
    /* ==================== H5 移动端页面 ==================== */
    {path: '/login_h5', name: 'login_h5', component: LoginH5},
    {path: '/register_h5', name: 'register_h5', component: RegisterH5},
    {path: '/password_h5', name: 'password_h5', component: PasswordH5},
    {path: '/home_h5', name: 'home_h5', component: HomeH5},
    {path: '/person_h5', name: 'person_h5', component: PersonH5},
    {path: '/meeting_h5', name: 'meeting_h5', component: MeetingH5},
    {path: '/meeting_h5_loop', name: 'meeting_h5_loop', component: MeetingH5Loop},
    {path: '/user_h5', name: 'user_h5', component: UserH5},
    {path: '/role_h5', name: 'role_h5', component: RoleH5},
    {path: '/document_h5', name: 'document_h5', component: DocumentH5}]


/*创建一个名为router的VueRouter实例，传入mode、base和routes作为参数。mode设置为history表示使用HTML5的History模式，
base设置为process.env.BASE_URL表示路由的基础路径，routes是前面定义的路由配置数组。*/
const router = new VueRouter({
    mode: 'history', base: process.env.BASE_URL, routes
})

/*定义了一个名为setRoutes的函数，用于动态添加路由。首先从localStorage中获取名为menuList的数据，然后遍历该数据，根据数据中的路径和名称动态生成路由配置，
并将其添加到finalRoute对象中。最后将finalRoute添加到路由实例中。*/
export const setRoutes = () => {
    const menuList = JSON.parse(localStorage.getItem("menuList"));
    if (menuList) {
        // 动态添加到现有路由
        const routeNameList = router.getRoutes().map(v => v.name)
        if (!routeNameList.includes('composite')) {
            const finalRoute = { // 动态的添加进去
                path: '/',
                component: Composite,
                name: 'composite',
                redirect: "/login",
                children: [
                    {path: '/person', name: '个人信息', component: Person}, // 固定路由！
                    {path: '/meeting_loop', name: '循环记录', component: AMeetingLoop},
                    // ===== 统一管理（FTP 文件管理）固定路由 =====
                    {path: '/admin/user', name: '操作员管理', component: () => import('@/vue_views/admin/AUserList.vue')},
                    {path: '/admin/task', name: '任务管理', component: () => import('@/vue_views/admin/ATaskList.vue')},
                    {path: '/admin/sound', name: '提示音管理', component: () => import('@/vue_views/admin/ASoundManage.vue')},
                    {path: '/admin/data', name: '任务数据', component: () => import('@/vue_views/admin/ATaskData.vue')},
                ]
            }
            menuList.forEach(item => {
                if (item.path) { // 一级路由
                    let menu = {
                        path: item.path.replace("/", ""),
                        name: item.name,
                        component: () => import('../vue_views/' + item.vue + '.vue')
                    }
                    finalRoute.children.push(menu)
                } else if (item.children.length) {
                    item.children.forEach(subItem => { // 二级路由
                        if (subItem.path) {
                            let subMenu = {
                                path: subItem.path.replace("/", ""),
                                name: subItem.name,
                                component: () => import('../vue_views/' + subItem.vue + '.vue')
                            }
                            finalRoute.children.push(subMenu)
                        }
                    })
                }
            })
            router.addRoute(finalRoute)
        }
    }
}

/*定义了一个名为clearRouter的函数，用于重置路由。通过重新创建一个新的VueRouter实例并赋值给router.matcher来实现路由的重置。*/
export const clearRouter = () => {
    router.matcher = new VueRouter({
        mode: 'history', base: process.env.BASE_URL, routes
    })
}
/*调用setRoutes()函数，用于在页面刷新时更新路由。*/
setRoutes();
/*使用router.beforeEach方法定义了一个全局前置守卫，用于在路由切换前执行一些操作。在这个例子中，它将即将访问的路由名称存储到localStorage中，
并触发状态管理库中的数据更新。如果找不到匹配的路由，则根据是否存在菜单信息跳转到相应的页面。*/
router.beforeEach((to, from, next) => {
    localStorage.setItem("currentPathName", to.name) // 设置即将访问的路由名称，为了在Header中使用
    myVuex.commit("setStateCurrentPathName") // 触发myVuex里的数据更新

    // ===== 登录校验：所有页面（登录页除外）必须已登录（localStorage.user.name 非空）=====
    const isLoginPage = to.path === '/login' || to.path === '/login_h5';
    if (!isLoginPage) {
        let userName = '';
        try {
            const userStr = localStorage.getItem('user');
            if (userStr) {
                const userObj = JSON.parse(userStr);
                userName = (userObj && userObj.name) ? userObj.name : '';
            }
        } catch (e) { /* ignore */ }
        if (!userName) {
            // 提示并跳转登录页：H5 路由跳 H5 登录页，PC 路由跳 PC 登录页
            try {
                Message.warning('请先登录');
            } catch (e) { alert('请先登录'); }
            const isH5 = to.path.indexOf('h5') !== -1;
            next(isH5 ? '/login_h5' : '/login');
            return;
        }
    }

    if (to.matched.length === 0) { // 未找到路由的情况
        const storeMenuList = localStorage.getItem("menuList")
        if (storeMenuList) {
            next("/404")
        } else {
            next("/login") // 如果没有菜单信息跳转到登录页面
        }
    }
    next() // 放行
})


/*最后导出router实例，以便在其他地方使用。*/
export default router
